











import {Component, Prop, Mixins} from 'vue-property-decorator'
import Assets from '@/mixins/Assets'

type AddType = 'cert' | 'add' | 'enter'

@Component
export default class AddImg extends Mixins(Assets) {
  @Prop({default: '', type: String}) addType: AddType
  @Prop({default: 30, type: Number}) width: number

  get style() {
    return {
      width: `${this.width}px`,
    }
  }
}
